import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import Preloader from './Preloader';
import { AuthProvider, useAuth } from './AuthContext';

import Navbar from './Navbar';
import Footer from './Footer';
import WhatsAppButton from './WhatsAppButton';

import PublicSite from './PublicSite';
import ProductsPage from './ProductsPage';
import About from './About';
import Login from './Login';
import AdminPortal from './AdminPortal';

import './index.css';

const AdminLoaderWrapper = ({ children }) => {
  const [isAdminLoading, setIsAdminLoading] = useState(true);

  return (
    <>
      <AnimatePresence mode="wait">
        {isAdminLoading && (
          <Preloader onFinished={() => setIsAdminLoading(false)} />
        )}
      </AnimatePresence>
      {!isAdminLoading && children}
    </>
  );
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) return (
    <div className="h-screen bg-white flex flex-col items-center justify-center overflow-hidden">
      <div className="w-10 h-10 border-4 border-gray-100 border-t-[#a6192e] rounded-full animate-spin mb-6" />
      
      <div className="flex flex-col items-center gap-2">
        <span className="text-slate-900 font-black italic uppercase tracking-tighter text-2xl">
          Verificando <span className="text-[#a6192e]">Acceso</span>
        </span>
        <span className="text-[10px] text-slate-400 font-bold uppercase tracking-[0.4em] animate-pulse">
          Seguridad Diana Grupo
        </span>
      </div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] bg-[#a6192e]/5 rounded-full blur-[120px] pointer-events-none" />
    </div>
  );

  return isAuthenticated ? children : <Navigate to="/login" replace />;
};

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main>{children}</main>
    <WhatsAppButton />
    <Footer />
  </>
);

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/" element={
            <PublicLayout>
              <PublicSite />
            </PublicLayout>
          } />

          <Route path="/productos" element={
            <PublicLayout>
              <ProductsPage />
            </PublicLayout>
          } />

          <Route path="/nosotros" element={
            <PublicLayout>
              <About />
            </PublicLayout>
          } />

          <Route path="/login" element={<Login />} />

          <Route
            path="/admin/*"
            element={
              <ProtectedRoute>
                <AdminLoaderWrapper>
                  <AdminPortal />
                </AdminLoaderWrapper>
              </ProtectedRoute>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;